import { render, staticRenderFns } from "./DestroyPosition.vue?vue&type=template&id=4dd4c5de&"
import script from "./DestroyPosition.vue?vue&type=script&lang=js&"
export * from "./DestroyPosition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports